import { Component, OnInit } from '@angular/core';
import { OrganisationInteractionService } from '../../../services';
import { IOrganisationInteraction } from '../../../interfaces/interactions/organisation-interaction';
import { Input } from '@angular/core';

@Component({
  selector: 'latest-interaction',
  templateUrl: './latest-interaction.component.html',
  styleUrls: ['./latest-interaction.component.scss'],
})
export class LatestInteractionComponent implements OnInit {
  constructor(private interactionService: OrganisationInteractionService) {}

  @Input() organisationId: number;
  @Input() recentCalls: any[];

  interaction: IOrganisationInteraction;

  interactionDate: Date;
  warningLevel: number;

  async ngOnInit() {
    this.interactionDate = null;

    await this.interactionService.getLatestInteraction(this.organisationId).then((res) => {
      this.interaction = res;

      if (this.interaction) {
        this.interactionDate = this.interaction.addedDate;
      }
    });

    // get latest date from recent calls if closer to now than interaction
    if (
      this.recentCalls &&
      this.recentCalls.length > 0 &&
      (this.recentCalls[0].created > this.interactionDate || !this.interactionDate)
    ) {
      this.interactionDate = this.recentCalls[0].created;
    }

    const wl = this.interactionService.getWarningLevel(this.interactionDate);
    this.warningLevel = wl;
  }
}
